import { Link } from 'react-router-dom';
import StatusScreen from '../components/StatusScreen';

export default function NotFound() {
  return (
    <StatusScreen
      kicker="404"
      title="Страница не найдена"
      description="Проверьте адрес или вернитесь в рабочее место геолога."
      action={
        <Link className="button button--primary" to="/agents/geologist/workspace">
          В рабочее место
        </Link>
      }
    />
  );
}
